// src/utils/imageUtils.ts
export type ImageSize = "tiny" | "thumb" | "medium" | "large";

/**
 * Given a base Cloudflare CDN image URL, generate variants
 * (tiny, thumbnail, medium, large) based on naming convention.
 * 
 * Input format: https://images.heysrilanka.com/ENT-00759577_1.jpg
 * Output variants: https://images.heysrilanka.com/ENT-00759577_1_tiny.webp, etc.
 */
export function getImageVariants(baseUrl: string | null): { 
  original: string | null; 
  tiny: string | null;
  thumb: string | null; 
  medium: string | null; 
  large: string | null;
} {
  // Handle null, undefined, and string "null"/"undefined" values
  if (!baseUrl || baseUrl === 'null' || baseUrl === 'undefined' || baseUrl.trim() === '') {
    return { original: null, tiny: null, thumb: null, medium: null, large: null };
  }

  // Cloudflare CDN format: https://images.heysrilanka.com/ENT-00759577_1.jpg
  // Extract filename without extension
  const lastSlashIndex = baseUrl.lastIndexOf('/');
  const baseUrlWithoutFile = baseUrl.substring(0, lastSlashIndex + 1);
  const filename = baseUrl.substring(lastSlashIndex + 1);
  
  // Remove extension (.jpg, .jpeg, .png, .webp)
  const nameWithoutExt = filename.replace(/\.(jpe?g|png|webp)$/i, '');
  
  // Generate variant URLs
  return {
    original: baseUrl,
    tiny: `${baseUrlWithoutFile}${nameWithoutExt}_tiny.webp`,
    thumb: `${baseUrlWithoutFile}${nameWithoutExt}_thumb.webp`,
    medium: `${baseUrlWithoutFile}${nameWithoutExt}_medium.webp`,
    large: `${baseUrlWithoutFile}${nameWithoutExt}_large.webp`,
  };
}